// src/hooks/useLogout.ts
import { useState } from 'react';
import config from '../config';
import { UserProfile } from '../interfaces';

const useLogout = () => {
  const [error, setError] = useState<string | null>(null);

  const logout = async (account: UserProfile | null): Promise<boolean> => {
    console.log(account);
    if (!account) {
      setError('No account provided');
      return true;
    }
    if (!account.token) {
      setError('No token provided');
      return true;
    }

    try {
      const response = await fetch(`${config.centralApiBaseUrl}/session/logout`, {
        method: 'DELETE',
        headers: {
          'Access-Control-Allow-Origin': '*',
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${account.token}`,
        },
      });

      if (!response.ok) {
        throw new Error('Logout failed');
      }
      localStorage.removeItem("isExternalLogin");
      return true;
    } catch (err) {
      setError(err instanceof Error ? err.message : 'An unknown error occurred');
      return false;
    }
  };

  return { logout, error };
};

export default useLogout;
